import { DictionaryItem } from "view360Card/models";
import { DictionaryItemDto } from "view360Card/service/dtos/DictionaryItemDto";

export class DictionaryItemFromDefinedResponse {
    constructor(private dto: DictionaryItemDto) {}

    domainModel(): DictionaryItem {
        return {
            id: this.dto.id,
            code: this.dto.code,
            deleted: this.dto.deleted,
            descriptionTranslationCode: this.dto.descriptionTranslationCode,
            description: this.dto.description,
            flexField1: this.dto.flexField1,
            orderIndex: this.dto.orderIndex,
            flexFilter1: this.dto.flexFilter1 ?? [],
        };
    }
}
